export const memberCouponpack = {
  btn_go_history: 'n.3529.6617.0',
  btn_go_coupon_list: 'n.3529.6618.0',
  btn_go_pay: 'n.3530.6619.0'
}
